export default {
    selfies: []
  }
  